import { Component, EventEmitter, forwardRef, Inject, Input, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { Alert, Thing } from "../../model";
import { AlertDefinitionService } from "../../service/alert-definition.service";
import { ThingService } from "../../service/thing.service";
import { UiService } from "../../service/ui.service";
import { DurationFormatterPipe } from "../../shared/pipe";
import { EventSelectionInputDialogComponent } from "./event-selection-input-dialog.component";

@Component({
    selector: 'event-selection-input',
    template: require('./event-selection-input.component.html')
})
export class EventSelectionInputComponent implements OnInit {

    @Input() label: string;

    @Input() description: string;

    @Input() resource: string;

    @Input() thing: Thing;

    @Input() visibleEventSeverities: string[];

    @Input() eventId: string;

    @Input() disabled: boolean;

    @Input() showEventDetailsButton: boolean = true;

    @Output() selectionChanged = new EventEmitter<Alert>();

    selectedEvent: Alert;
    isHistoricalEvent: boolean;
    loading: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog,
        @Inject(forwardRef(() => ThingService)) private thingService: ThingService,
        @Inject(forwardRef(() => DurationFormatterPipe)) private durationFormatterPipe: DurationFormatterPipe,
        @Inject(forwardRef(() => AlertDefinitionService)) private alertDefinitionService: AlertDefinitionService,
        @Inject(forwardRef(() => UiService)) private uiService: UiService
    ) { }

    ngOnInit(): void {
        if (this.eventId) {
            this.loadSelectedEvent();
        }
    }

    private loadSelectedEvent(): void {
        this.loading = true;
        this.thingService.getAlertById(this.eventId).then(event => {
            this.enrichEvent(event);
        }).catch(() => this.thingService.getHistoricalAlertById(this.eventId).then(historicalEvent => {
            this.isHistoricalEvent = true;
            this.enrichEvent(historicalEvent);
        }).catch(() => console.error("Invalid event")));
    }

    private enrichEvent(event: Alert): void {
        this.alertDefinitionService.getAlertDefinitionById(event.alertDefinitionId).then(aDef => {
            event['duration'] = this.durationFormatterPipe.transform({ startTimestamp: event.startTimestamp, endTimestamp: event.endTimestamp });
            event['showDetailsButton'] = (aDef?.templateName || !!this.uiService.getEventDetailsTemplate()) && event.thing != null && this.showEventDetailsButton;
            this.selectedEvent = event;
            this.loading = false;
            this.selectionChanged.emit(this.selectedEvent);
        });
    }


    getSelectedEvent(): Alert {
        return this.selectedEvent;
    }

    openEventSelectionDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '800px';
        dialogConfig.data = { thing: this.thing, eventSeverities: this.visibleEventSeverities };
        firstValueFrom(this.dialog.open(EventSelectionInputDialogComponent, dialogConfig).afterClosed()).then(result => {
            if (result) {
                this.selectedEvent = result.event;
                this.isHistoricalEvent = result.isHistorical;
                this.selectionChanged.emit(this.selectedEvent);
            }
        });
    }
}